import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers} from 'redux';
import thunk from 'redux-thunk';

import './index.scss';
import App from './App';
import ScrollToTop from './containers/ScrollToTop/ScrollToTop';

import flightsReducer from './store/reducers/flights';
import hotelsReducer from './store/reducers/hotels';
import navigationReducer from './store/reducers/navigation';
import uiReducer from './store/reducers/ui';
import travellersReducer from './store/reducers/travellers';
import hotelTravellersReducer from './store/reducers/hotelTravellers';
import fareRulesReducer from './store/reducers/fareRules';
import farePriceReducer from './store/reducers/farePrice';
import baggageReducer from './store/reducers/baggage';
import authenticationReducer from './store/reducers/auth';
import stackFlightReducer from './store/reducers/stackDepartureTuple';
import bookingEngineReducer from './store/reducers/bookingEngine';
import hotelBookingEngineReducer from './store/reducers/bookingEngineHotel';
import lowestFareReducer from './store/reducers/lowestFare';
import roundTripSummaryReducer from './store/reducers/roundTripSummary';
import paymentsReducer from './store/reducers/payments';
import seatsReducer from './store/reducers/seats';
import userReducer from './store/reducers/user';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
    flights: flightsReducer,
    hotels: hotelsReducer,
    navigation: navigationReducer,
    ui: uiReducer,
    travellers: travellersReducer,
    hotelTravellers: hotelTravellersReducer,
    fareRules: fareRulesReducer,
    farePrice: farePriceReducer,
    baggage: baggageReducer,
    auth: authenticationReducer,
    stackFlight: stackFlightReducer,
    bookingEngine: bookingEngineReducer,
    hotelBookingEngine: hotelBookingEngineReducer,
    lowestFare: lowestFareReducer,
    roundTripSummary: roundTripSummaryReducer,
    payments: paymentsReducer,
    seats: seatsReducer,
    user: userReducer
});

const rootReducer = (state, action) => {
    if(action.type === "RESET_ALL") {
        state = undefined;
    }
    return appReducer(state, action);
}

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const app = (
        <Provider store={store}>
            <BrowserRouter basename='quicksilver'>
                <ScrollToTop>
                    <App />
                </ScrollToTop>
            </BrowserRouter>
        </Provider>
);

ReactDOM.render(app, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js